import React from 'react';
import { Box } from 'wix-style-react';
import { Category } from '../models';
import MarketplaceServiceLink from '../MarketplaceServiceLink';

interface MarketplaceServiceLinkGroupProps {
  category: Category;
  marketplaceUrlPrefix: string;
  pageName: string;
}

const ServiceLinkGroup = ({
  category,
  marketplaceUrlPrefix,
  pageName,
}: MarketplaceServiceLinkGroupProps) => {
  return (
    <Box backgroundColor="#0006240d" direction="vertical">
      {category.services
        .filter((service) => !service.hidden)
        .map((service) => (
          <MarketplaceServiceLink
            key={service.displayKey}
            service={service}
            categoryPathName={category.pathName}
            marketplaceUrlPrefix={marketplaceUrlPrefix}
            pageName={pageName}
          />
        ))}
      <MarketplaceServiceLink
        service={category}
        marketplaceUrlPrefix={marketplaceUrlPrefix}
        pageName={pageName}
      />
    </Box>
  );
};

export default ServiceLinkGroup;
